import { render, staticRenderFns } from "./RenovarBase.vue?vue&type=template&id=e5c68320"
import script from "./RenovarBase.vue?vue&type=script&lang=js"
export * from "./RenovarBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports